module.exports = __webpack_public_path__ + "media/svg-new/trophy-30d5288f.svg";